import React, { useState, useEffect } from 'react';
import './ElementDialog.css';
import Select from 'react-select';

const ElementDialog = ({
  elementType,
  onSubmit,
  elementDialogVisible,
  setElementDialogVisible,
  selectedFields,
  currentFormId,
  fields,
  accountFields,
  handleFieldSelect,
  setSelectedOption1,
  selectedOption1,
  editedElement,
  setEditedElement,
  dropconditional,
  dropelementId,
  onSubmit1,
  selectedConditionalOption
}) => {
  const [name, setName] = useState('');
  const [options, setOptions] = useState('');
  const [selectedField, setSelectedField] = useState(null);
  // const [isNumberValidationEnabled, setIsNumberValidationEnabled] = useState(false);
  const [isMandatory, setIsMandatory] = useState(false);
  const [isConditional, setIsConditional] = useState(false); // New state for mandatory checkbox
  const [validationType, setValidationType] = useState(''); // New state for validation type radio buttons
  const [conditional, setConditional] = useState([]);
  const [selectedOption2, setSelectedOption2] = useState(null);
  const [isReadOnly, setIsReadOnly] = useState(false);
{console.log(accountFields)}
  useEffect(() => {
    if (editedElement) {
      { console.log(editedElement) }
      setName(editedElement.name || '');
      setOptions(editedElement?.options ? editedElement?.options?.join(', ') : '');
      setSelectedOption1(editedElement.selectedOption ? { value: editedElement.selectedOption, label: editedElement.selectedOption } : null);
      setIsMandatory(editedElement.isMandatory || false); // Populate if editedElement has isMandatory
      setValidationType(editedElement.validationType || '');
      setIsConditional(editedElement.isConditional || '')
      setConditional(editedElement.conditional || [])
      // Populate if editedElement has validationType
      if (elementType == 'Height Field') {
        setSelectedOption2(editedElement.selectedOption2 ? { value: editedElement.selectedOption2, label: editedElement.selectedOption2 } : null);
      }
      setIsReadOnly(editedElement.isReadOnly || false);
    }
  }, [editedElement]);

  const handleCancel = () => {
    setEditedElement(null);
    setElementDialogVisible(false);
    setName('');
    setOptions('');
    setSelectedOption1(null);
    setSelectedOption2(null);
    //  setIsNumberValidationEnabled(false);
    setIsMandatory(false); // Reset state
    setValidationType('');
    setConditional([])// Reset state
    setIsReadOnly(false);
  };

  const handleSave = () => {
    if (!name.trim()) {
      alert('Please enter a valid name.');
      return;
    }

    if (['Checkbox', 'Radiobutton', 'Dropdown'].includes(elementType) && !options) {
      alert('Please enter options.');
      return;
    }


    if (elementType != 'Signature') {
      if (!selectedOption1) {
        alert('Please select a value from the dropdown.');
        return;
      }
    }
    //alert(isConditional);
    //alert(dropelementId);
    //alert(dropconditional);
    const elementData = {
      name,
      options: options ? options.toString().split(',').map(option => option.trim()) : [],
      selectedOption2,
      isMandatory,
      isReadOnly, // Save the state of mandatory checkbox
      validationType,
      isConditional,
      dropconditional,
      dropelementId,
      conditional,

      // Save the selected validation type
    };

    onSubmit(elementData);

    handleCancel(); // Reset form after saving
  };

  return (
    elementDialogVisible && (
      <div className="element-dialog-container">
        <div className="element-dialog active">
          <label>
            {elementType} Name:
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
          </label>
          {console.log(elementType)}
          {(elementType !== 'Payment' && elementType !== 'Signature' && elementType !== 'PatientName And Date' && elementType !== 'cctype' && elementType !== 'ccdatepicker') && (
    <>
        <Select
            value={selectedOption1}
            onChange={(selectedOption) => {
                setSelectedOption1(selectedOption);
                setSelectedField(selectedOption.value);
                const selectedFieldData = fields.find((field) => field.name === selectedOption.value);
                setOptions(selectedFieldData ? selectedFieldData.picklistValues.map(value => value.label) : []);
            }}
            options={fields.map(option => ({ value: option.name, label: option.name?.replace(/^HQ_|__c$|__s$/g, '') }))}
            isSearchable={true}
            placeholder={`Select value for ${name.toLowerCase()}...`}
        />
              {
                elementType == 'Height Field' && (

                  <Select
                    value={selectedOption2}
                    onChange={(selectedOption) => {
                      setSelectedOption2(selectedOption);

                    }}
                    options={fields.map(option => ({ value: option.name, label: option.name?.replace(/^HQ_|__c$|__s$/g, '') }))}
                    isSearchable={true}
                    placeholder={`Select value for ${name.toLowerCase()}...`}
                  />

                )
              }
              {console.log(elementType)}
                
            </>
          )}
          {['Checkbox', 'Dropdown', 'MultiSelectCheckbox' ].includes(elementType) && (
            <>
              {selectedField && (
                <div>
                  <h3>Options for {name}:</h3>
                  <ul>
                    {options?.map((value, index) => (
                      <li key={index}>{value}</li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          )}
{
                (elementType=='Payment' || elementType=='cctype' || elementType=='ccdatepicker') && (
                  <>

                  <Select
                value={selectedOption1}
                onChange={(selectedOption) => {
                  setSelectedOption1(selectedOption);
                  setSelectedField(selectedOption.value);
                  const selectedFieldData = accountFields.find((field) => field.name === selectedOption.value);
                  setOptions(selectedFieldData ? selectedFieldData.picklistValues.map(value => value.label) : []);
                }}
                options={accountFields?.map(option => ({ value: option.name, label: option.name?.replace(/^HQ_|__c$|__s$/g, '') }))}
                isSearchable={true}
                placeholder={`Select value for ${name.toLowerCase()}...`}
              />
</>
                )
              }
          {(elementType === 'Checkbox' || elementType == 'Dropdown' || elementType == 'MultiSelectCheckbox') && (
            <label>
              conditional:
              <input
                type="checkbox"
                checked={isConditional}
                onChange={(e) => setIsConditional(e.target.checked)}
              />
            </label>
          )}
          <label>
            Mandatory Field:
            <input
              type="checkbox"
              checked={isMandatory}
              onChange={(e) => setIsMandatory(e.target.checked)}
            />
          </label>

          <label>
            Read Only Field:
            <input
              type="checkbox"
              checked={isReadOnly}
              onChange={(e) => setIsReadOnly(e.target.checked)}
            />
          </label>
          {(elementType === 'Text Field' || elementType == "ConsentTextField" || elementType=='Payment'|| elementType=='Address') && (
            <>

              <div>
                Validation Type:
                <label>
                  <input
                    type="radio"
                    value="email"
                    checked={validationType === 'email'}
                    onChange={(e) => setValidationType(e.target.value)}
                  />
                  Email
                </label>
                <label>
                  <input
                    type="radio"
                    value="number"
                    checked={validationType === 'number'}
                    onChange={(e) => setValidationType(e.target.value)}
                  />
                  Number
                </label>
                <label>
                  <input
                    type="radio"
                    value="phone"
                    checked={validationType === 'phone'}
                    onChange={(e) => setValidationType(e.target.value)}
                  />
                  Phone Number
                </label>
                <label>
                  <input
                    type="radio"
                    value="cvv"
                    checked={validationType === 'cvv'}
                    onChange={(e) => setValidationType(e.target.value)}
                  />
                  CVV
                </label>
                <label>
                  <input
                    type="radio"
                    value="ssn"
                    checked={validationType === 'ssn'}
                    onChange={(e) => setValidationType(e.target.value)}
                  />
                  SSN
                </label>
                <div>
     
    </div>
              </div>
            </>
          )}

          <button onClick={handleCancel}>Cancel</button>
          <button onClick={handleSave}>Save</button>
        </div>
      </div>
    )
  );
};

export default ElementDialog;
